import { GET_CONTACT_ID, GET_TOKEN } from '@/store/constants/opens'

export default {
  [GET_CONTACT_ID]: state => state.opens.contactID,
  [GET_TOKEN]: state => state.opens.token
}
